import { render } from "./FlagEN.vue?vue&type=template&id=c8e23b1a"
import script from "./FlagEN.vue?vue&type=script&lang=js"
export * from "./FlagEN.vue?vue&type=script&lang=js"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__